import { isBlockSolid, BlockType } from "../world/block-registry";

export type WorldBlockAccess = {
  getBlockAtWorld(wx: number, wy: number, wz: number): BlockType;
};

export type CollisionResult = {
  x: number;
  y: number;
  z: number;
  onGround: boolean;
  hitCeiling: boolean;
};

export function resolveCollision(
  posX: number,
  posY: number,
  posZ: number,
  velX: number,
  velY: number,
  velZ: number,
  width: number,
  height: number,
  dt: number,
  world: WorldBlockAccess
): CollisionResult {
  const halfW = width / 2;
  let newX = posX;
  let newY = posY;
  let newZ = posZ;
  let onGround = false;
  let hitCeiling = false;

  // --- Resolve Y axis first (gravity dominant) ---
  const dyTotal = velY * dt;
  newY = posY + dyTotal;

  if (dyTotal !== 0) {
    const minX = Math.floor(newX - halfW);
    const maxX = Math.floor(newX + halfW - 0.001);
    const minZ = Math.floor(newZ - halfW);
    const maxZ = Math.floor(newZ + halfW - 0.001);

    if (dyTotal < 0) {
      const checkY = Math.floor(newY);
      for (let bx = minX; bx <= maxX; bx++) {
        for (let bz = minZ; bz <= maxZ; bz++) {
          if (isBlockSolid(world.getBlockAtWorld(bx, checkY, bz))) {
            newY = checkY + 1;
            onGround = true;
            break;
          }
        }
        if (onGround) break;
      }
    } else {
      const checkY = Math.floor(newY + height);
      for (let bx = minX; bx <= maxX; bx++) {
        for (let bz = minZ; bz <= maxZ; bz++) {
          if (isBlockSolid(world.getBlockAtWorld(bx, checkY, bz))) {
            newY = checkY - height;
            hitCeiling = true;
            break;
          }
        }
        if (hitCeiling) break;
      }
    }
  }

  // --- Resolve X axis ---
  const dxTotal = velX * dt;
  newX = posX + dxTotal;

  if (dxTotal !== 0) {
    const minY = Math.floor(newY);
    const maxY = Math.floor(newY + height - 0.001);
    const minZ = Math.floor(newZ - halfW);
    const maxZ = Math.floor(newZ + halfW - 0.001);

    if (dxTotal > 0) {
      const checkX = Math.floor(newX + halfW);
      let blocked = false;
      for (let by = minY; by <= maxY; by++) {
        for (let bz = minZ; bz <= maxZ; bz++) {
          if (isBlockSolid(world.getBlockAtWorld(checkX, by, bz))) {
            newX = checkX - halfW;
            blocked = true;
            break;
          }
        }
        if (blocked) break;
      }
    } else {
      const checkX = Math.floor(newX - halfW);
      let blocked = false;
      for (let by = minY; by <= maxY; by++) {
        for (let bz = minZ; bz <= maxZ; bz++) {
          if (isBlockSolid(world.getBlockAtWorld(checkX, by, bz))) {
            newX = checkX + 1 + halfW;
            blocked = true;
            break;
          }
        }
        if (blocked) break;
      }
    }
  }

  // --- Resolve Z axis ---
  const dzTotal = velZ * dt;
  newZ = posZ + dzTotal;

  if (dzTotal !== 0) {
    const minY = Math.floor(newY);
    const maxY = Math.floor(newY + height - 0.001);
    const minX2 = Math.floor(newX - halfW);
    const maxX2 = Math.floor(newX + halfW - 0.001);

    if (dzTotal > 0) {
      const checkZ = Math.floor(newZ + halfW);
      let blocked = false;
      for (let by = minY; by <= maxY; by++) {
        for (let bx = minX2; bx <= maxX2; bx++) {
          if (isBlockSolid(world.getBlockAtWorld(bx, by, checkZ))) {
            newZ = checkZ - halfW;
            blocked = true;
            break;
          }
        }
        if (blocked) break;
      }
    } else {
      const checkZ = Math.floor(newZ - halfW);
      let blocked = false;
      for (let by = minY; by <= maxY; by++) {
        for (let bx = minX2; bx <= maxX2; bx++) {
          if (isBlockSolid(world.getBlockAtWorld(bx, by, checkZ))) {
            newZ = checkZ + 1 + halfW;
            blocked = true;
            break;
          }
        }
        if (blocked) break;
      }
    }
  }

  return { x: newX, y: newY, z: newZ, onGround, hitCeiling };
}
